const isCardinalActive = cardinal => {
  if (cardinal) {
    if (
      cardinal.indefinite && 
      cardinal.indefiniteStart && 
      Date.now() > cardinal.indefiniteStart
    ) {
      return true;
    } else if (cardinal.indefinite && !cardinal.indefiniteStart) {
      return true
    } else if (cardinal.time) {
      const nowTimestamp = Date.now();
      const { start, end } = cardinal.time;
      return start <= nowTimestamp && nowTimestamp < end;
    } else {
      return false;
    }
  } else {
    return false;
  }
};

export default isCardinalActive;